import { ChainURL, EnrichedChainURL } from '@ankr.com/chains-list';

function isEnrichedURL(
  url: ChainURL | EnrichedChainURL,
): url is EnrichedChainURL {
  return 'name' in url;
}

export const getEndpointName = (
  urls: (ChainURL | EnrichedChainURL)[],
  endpoint: string,
): string => {
  const foundUrl = urls.find(url => Object.values(url).includes(endpoint));

  if (foundUrl && isEnrichedURL(foundUrl)) {
    return foundUrl.name;
  }

  return '';
};
